import { array } from 'fp-ts';
import { constVoid } from 'fp-ts/lib/function';

export interface LastNSum {
  getSum: () => number;
  push: (value: number) => void;
  reset: () => void;
}

/**
 * Create an object that sums last N pushed numbers
 *
 * Note: the code is optimized for least allocations possible
 * to be usable in performance-critical spots.
 */
export function createLastNSum(n: number, initialNumbers = 0): LastNSum {
  const frames = array.replicate(n, initialNumbers);
  let ptr = 0;
  let sum = initialNumbers * n;
  return {
    getSum: () => sum,
    push:
      n === 0
        ? constVoid
        : (value: number) => {
            // Fixed noUncheckedIndexedAccess NIM-19408
            sum += value - frames[ptr]!;
            frames[ptr] = value;
            ptr = (ptr + 1) % n;
          },
    reset: () => {
      for (let i = 0; i < n; i += 1) {
        frames[i] = initialNumbers;
        sum = initialNumbers * n;
      }
    },
  };
}
